import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './call/HttpClientCall.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { defaultTransformers2r9wd7ftt31zw as defaultTransformers } from './plugins/DefaultTransform.mjs';
import {
  get_HttpResponseReceiveFailed2q0s5em07bm9j as get_HttpResponseReceiveFailed,
  HttpResponseReceiveFailk4vfmxmwithf as HttpResponseReceiveFail,
  get_HttpRequestCreated2xa7wfn254wyu as get_HttpRequestCreated,
} from './utils/ClientEvents.mjs';
import {
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
  HttpResponsePipeline14ucx7kbf4hm2 as HttpResponsePipeline,
  HttpReceivePipeline1ousblrss634z as HttpReceivePipeline,
  Phases_getInstance1ydmp5ct4mzr8 as Phases_getInstance,
} from './statement/HttpResponsePipeline.mjs';
import { HttpClientConfigo6p492ed655g as HttpClientConfig } from './HttpClientConfig.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import {
  Key_instance2rlngjw9v1qsd as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  HttpRequestPipeline1v7xct5dgezuy as HttpRequestPipeline,
  HttpSendPipeline3tm1hram7cjxt as HttpSendPipeline,
  Phases_getInstance2itgh2akpxu95 as Phases_getInstance_0,
} from './request/HttpRequestPipeline.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { Events63tfxre48w4z as Events } from '../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { get_HttpRequestLifecycle1e7j0z243lnj5 as get_HttpRequestLifecycle } from './plugins/HttpRequestLifecycle.mjs';
import { get_BodyProgresstom4nhodv8bj as get_BodyProgress } from './plugins/BodyProgress.mjs';
import { get_SaveBody3aignvhtsnvcr as get_SaveBody } from './plugins/SaveBody.mjs';
import { Plugin_getInstance1dclwrituae7c as Plugin_getInstance } from './plugins/HttpSend.mjs';
import { get_HttpCallValidator3iji36qylbtbr as get_HttpCallValidator } from './plugins/HttpCallValidator.mjs';
import { get_HttpRedirect1lgx3wewnhrb0 as get_HttpRedirect } from './plugins/HttpRedirect.mjs';
import { get_HttpPlainText2hd9sygnz4kij as get_HttpPlainText } from './plugins/HttpPlainText.mjs';
import { addDefaultResponseValidation1d06vtgr9flaj as addDefaultResponseValidation } from './plugins/DefaultResponseValidation.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpClient$slambdaClass;
function HttpClient$slambda() {
  if (HttpClient$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.y5g_1 = this$0;
      }
      *z5g($this$intercept, call, $completion) {
        // Inline function 'kotlin.check' call
        if (!(call instanceof HttpClientCall())) {
          var message = 'Error: HttpClientCall expected, but found ' + toString(call) + '(' + toString(getKClassFromExpression(call)) + ').';
          throw IllegalStateException().o(toString(message));
        }
        var response = yield* this.y5g_1.j5h_1.n4s(Unit_instance, call.t5h(), $completion);
        call.u5h(response);
        yield* $this$intercept.q4r(call, $completion);
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.z5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpClient$slambdaClass = $;
  }
  return HttpClient$slambdaClass;
}
function HttpClient$slambda_0(this$0) {
  var i = new (HttpClient$slambda())(this$0);
  var l = ($this$intercept, call, $completion) => i.z5g($this$intercept, call, $completion);
  l.$arity = 2;
  return l;
}
function HttpClient$lambda($this$install) {
  defaultTransformers($this$install);
  return Unit_instance;
}
var HttpClient$slambdaClass_0;
function HttpClient$slambda_1() {
  if (HttpClient$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.v5h_1 = this$0;
      }
      *w5h($this$intercept, it, $completion) {
        try {
          yield* $this$intercept.r4r($completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            this.v5h_1.m5h_1.u4t(get_HttpResponseReceiveFailed(), new (HttpResponseReceiveFail())($this$intercept.o4s_1.t5h(), cause));
            throw cause;
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.w5h(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpClient$slambdaClass_0 = $;
  }
  return HttpClient$slambdaClass_0;
}
function HttpClient$slambda_2(this$0) {
  var i = new (HttpClient$slambda_1())(this$0);
  var l = ($this$intercept, it, $completion) => i.w5h($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var HttpClientClass;
function HttpClient() {
  if (HttpClientClass === VOID) {
    class $ {
      static x5h(engine, userConfig) {
        userConfig = userConfig === VOID ? new (HttpClientConfig())() : userConfig;
        var $this = createThis(this);
        $this.a5h_1 = engine;
        $this.b5h_1 = userConfig;
        $this.c5h_1 = false;
        $this.d5h_1 = atomic$boolean$1(false);
        $this.e5h_1 = Job($this.a5h_1.sv().yc(Key_instance));
        $this.f5h_1 = $this.a5h_1.sv().gm($this.e5h_1);
        $this.g5h_1 = new (HttpRequestPipeline())();
        $this.h5h_1 = new (HttpResponsePipeline())();
        $this.i5h_1 = new (HttpSendPipeline())();
        $this.j5h_1 = new (HttpReceivePipeline())();
        $this.k5h_1 = AttributesJsFn(true);
        $this.l5h_1 = $this.a5h_1.y5h();
        $this.m5h_1 = new (Events())();
        $this.n5h_1 = new (HttpClientConfig())();
        if ($this.c5h_1) {
          $this.e5h_1.vw((it) => {
            var tmp;
            if (!(it == null)) {
              cancel($this.a5h_1);
              tmp = Unit_instance;
            }
            return Unit_instance;
          });
        }
        $this.a5h_1.z5h($this);
        var tmp = Phases_getInstance_0().e5i_1;
        $this.i5h_1.s4s(tmp, HttpClient$slambda_0($this));
        // Inline function 'kotlin.with' call
        var $this$with = $this.b5h_1;
        $this.n5h_1.n5i(get_HttpRequestLifecycle());
        $this.n5h_1.n5i(get_BodyProgress());
        $this.n5h_1.n5i(get_SaveBody());
        if ($this$with.k5i_1) {
          $this.n5h_1.o5i('DefaultTransformers', HttpClient$lambda);
        }
        $this.n5h_1.n5i(Plugin_getInstance());
        $this.n5h_1.n5i(get_HttpCallValidator());
        if ($this$with.j5i_1) {
          $this.n5h_1.n5i(get_HttpRedirect());
        }
        $this.n5h_1.p5i($this$with);
        if ($this$with.k5i_1) {
          $this.n5h_1.n5i(get_HttpPlainText());
        }
        addDefaultResponseValidation($this.n5h_1);
        $this.n5h_1.z5h($this);
        var tmp_0 = Phases_getInstance().q5i_1;
        $this.h5h_1.s4s(tmp_0, HttpClient$slambda_2($this));
        return $this;
      }
      static v5i(engine, userConfig, manageEngine) {
        var $this = this.x5h(engine, userConfig);
        $this.c5h_1 = manageEngine;
        return $this;
      }
      sv() {
        return this.f5h_1;
      }
      *w5i(builder, $completion) {
        this.m5h_1.u4t(get_HttpRequestCreated(), builder);
        var tmp = yield* this.g5h_1.n4s(builder, builder.a5j_1, $completion);
        return tmp instanceof HttpClientCall() ? tmp : THROW_CCE();
      }
      l6() {
        var success = this.d5h_1.atomicfu$compareAndSet(false, true);
        if (!success)
          return Unit_instance;
        var installedFeatures = this.k5h_1.a4n(get_PLUGIN_INSTALLED_LIST());
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = installedFeatures.h4n().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var plugin = installedFeatures.a4n(element instanceof AttributeKey() ? element : THROW_CCE());
          if (isInterface(plugin, AutoCloseable())) {
            plugin.l6();
          }
        }
        this.e5h_1.k12();
        if (this.c5h_1) {
          this.a5h_1.l6();
        }
      }
      toString() {
        return 'HttpClient[' + toString(this.a5h_1) + ']';
      }
    }
    initMetadataForClass($, 'HttpClient', VOID, VOID, [CoroutineScope(), AutoCloseable()], [1]);
    HttpClientClass = $;
  }
  return HttpClientClass;
}
function HttpClient_0(engine, block) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  return HttpClient().v5i(engine, this_0, false);
}
function HttpClient_1(engineFactory, block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda_0;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  var config = this_0;
  var engine = engineFactory.d5j(config.i5i_1);
  var client = HttpClient().v5i(engine, config, true);
  var tmp_0 = ensureNotNull(client.f5h_1.yc(Key_instance));
  tmp_0.vw((it) => {
    engine.l6();
    return Unit_instance;
  });
  return client;
}
function HttpClient$lambda_0(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  HttpClient_0 as HttpClienthpouyso1j6ge,
  HttpClient_1 as HttpClient2x7qc5z8fmeal,
};
//endregion

//# sourceMappingURL=HttpClient.mjs.map
